// extracted by mini-css-extract-plugin
module.exports = {"main":"src-styles-templates-Default-__styles-module___main src-styles-_settings-__composes-module___flexcolumn"};